import React, { useReducer } from 'react';

export const RegistrationContext = React.createContext();

const initialStatus = {
  campaignRequest: null,
  campaign: null,
  patient: null,
  application: null,
};

const RegistrationReducer = (state, action) => {
  switch (action.type) {
    case 'set_registration':
      return {
        ...state,
        ...action.payload,
      };

    case 'set_campaign_request':
      return {
        ...state,
        campaignRequest: action.campaignRequest,
      };

    case 'set_campaign':
      return {
        ...state,
        campaign: action.campaign,
      };

    case 'set_patient':
      return {
        ...state,
        patient: action.patient,
      };

    case 'set_application':
      return {
        ...state,
        application: action.application,
      };

    default:
      return state;
  }
};

export const RegistrationContextProvider = (props) => {
  const [state, dispatch] = useReducer(RegistrationReducer, initialStatus);

  return (
    <RegistrationContext.Provider value={[state, dispatch]}>
      {props.children}
    </RegistrationContext.Provider>
  );
};
